import React, {useEffect, useState} from "react";
import S from './Registration.module.scss';
import {Checkbox, Select, TextInput} from "@mantine/core";
import {useNavigate} from "react-router-dom";
import {useFormContext} from "../../app/providers";
import {notifications} from "@mantine/notifications";
import { PatternFormat } from 'react-number-format';
import backgroundForCompany2 from "../../shared/assets/images/backgroundForCompany2.png";
import backgroundForCompany1 from "../../shared/assets/images/backgroundForCompany1.png";
import logistic from "../../shared/assets/images/imgLogistic.png";
import logistic3 from "../../shared/assets/images/imgLogistic3.png";

interface Props {
    event?: any;
}

export const Registration = ({event}: Props) => {
    const form = useFormContext();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    const [isEventDisabled, setIsEventDisabled] = useState(false);

    useEffect(() => {
        if (event) {
            const eventExists = eventsData.find(item => item.value === event);
            if (eventExists) {
                form.setFieldValue('event', eventExists?.label);
                setIsEventDisabled(true);
            } else {
                form.setFieldValue('event', event);
                setIsEventDisabled(true);
            }
        }
    }, [event]);

    const eventsData = [
        { value: 1, label: 'Цифровизация промышленности, Ноябрь 2026' },
        { value: 5, label: 'Транспорт и логистика, Декабрь 2026' },
    ];

    const sendRequest = async (values: typeof form.values) => {
        const formData = new FormData();
        formData.append('firstname', values.firstname);
        formData.append('lastname', values.lastname);
        formData.append('middlename', values.middlename || '');
        formData.append('company', values.company);
        formData.append('unit', values.unit);
        formData.append('position', values.position);
        formData.append('phone', values.phone.replace(/\D/g, ''));
        formData.append('email', values.email);
        formData.append('title', values.title || '');
        formData.append('event', values.event);
        formData.append('flag', JSON.stringify(values.flag));

        const response = await fetch('/api/v1/registration-legacy', {
            method: 'POST',
            body: formData,
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Ошибка ${response.status}: ${errorText || response.statusText}`);
        }

        return {success: true};
    };

    const handleSubmit = form.onSubmit(async (values) => {
        setIsLoading(true);

        try {
            await sendRequest(values);
            notifications.show({
                color: 'green',
                autoClose: 5000,
                title: 'Заявка успешно отправлена!',
                message: '',
            })
            form.reset();

        } catch (error) {
            notifications.show({
                color: 'red',
                autoClose: 5000,
                title: 'Произошла ошибка при отправке. Пожалуйста, попробуйте позже.',
                message: '',
            })
        } finally {
            setIsLoading(false);
        }
    });

    const handleSelectChange = (value: number | null, form: any) => {
        if (value) {
            const selectedEvent = eventsData.find(item => item.value === value);
            if (selectedEvent) {
                form.setFieldValue('event', selectedEvent.label);
            }
        } else {
            form.setFieldValue('event', '');
        }
    };

    return (
        <div className={S.content}>
            <div className={S.backgroundForCompany2}>
                {event === 5 ? (
                    <img src={logistic3} alt="logistic3"/>
                ) : (
                    <img src={backgroundForCompany2} alt="backgroundForCompany2"/>
                )}
            </div>
            <div className={S.title}>НЕ УПУСТИТЕ ВОЗМОЖНОСТЬ СТАТЬ ЧАСТЬЮ ЭТОГО ЗНАЧИМОГО СОБЫТИЯ
                И ИЗВЛЕЧЬ ИЗ НЕГО МАКСИМАЛЬНУЮ ПОЛЬЗУ!
            </div>
            <div>
                <form onSubmit={handleSubmit} className={S.boxForm}>
                    <div className={S.mainForm}>
                        <div className={S.mainFormBlock}>
                            <TextInput
                                label="Компания"
                                withAsterisk
                                size="lg"
                                className={S.textInput}
                                key={form.key('company')}
                                {...form.getInputProps('company')}
                            />
                            <TextInput
                                label="Подразделение"
                                withAsterisk
                                size="lg"
                                className={S.textInput}
                                key={form.key('unit')}
                                {...form.getInputProps('unit')}
                            />
                            <TextInput
                                label="Должность"
                                withAsterisk
                                size="lg"
                                className={S.textInput}
                                key={form.key('position')}
                                {...form.getInputProps('position')}
                            />
                        </div>
                        <div className={S.mainFormBlock}>
                            <TextInput
                                label="Фамилия"
                                withAsterisk
                                size="lg"
                                className={S.textInput}
                                key={form.key('lastname')}
                                {...form.getInputProps('lastname')}
                            />
                            <TextInput
                                label="Имя"
                                withAsterisk
                                size="lg"
                                className={S.textInput}
                                key={form.key('firstname')}
                                {...form.getInputProps('firstname')}
                            />
                            <TextInput
                                label="Отчество"
                                size="lg"
                                className={S.textInput}
                                key={form.key('middlename')}
                                {...form.getInputProps('middlename')}
                            />
                        </div>
                    </div>
                    <div className={S.mainForm}>
                        <div className={S.additionalFormBlock}>
                            <TextInput
                                label="Тема доклада"
                                size="lg"
                                className={S.textInput}
                                key={form.key('title')}
                                {...form.getInputProps('title')}
                            />
                            <div>
                                Если у вашей компании есть тема доклада, кейс
                                или готовое решение, укажите тему.
                            </div>
                        </div>
                        <Select
                            label="Мероприятие"
                            size="lg"
                            withAsterisk
                            className={S.textInput}
                            key={form.key('event')}
                            {...form.getInputProps('event')}
                            data={eventsData}
                            searchable
                            styles={{
                                option: {
                                    fontSize: 16,
                                },
                            }}
                            clearable={!isEventDisabled}
                            disabled={isEventDisabled}
                            value={eventsData.find(item => item.label === form.values.event)?.value || null}
                            onChange={(value) => handleSelectChange(value, form)}
                        />
                    </div>
                    <Checkbox
                        label={
                            <div className={S.checkFormLabel}>
                                Участвую в экскурсии на Череповецкий металлургический комбинат
                            </div>
                        }
                        key={form.key('flag')}
                        {...form.getInputProps('flag', {type: 'checkbox'})}
                        color="#0C31C8FF"
                    />
                    <div>
                        <div className={S.mainForm}>
                            <PatternFormat
                                label="Ваш номер телефона для связи"
                                withAsterisk
                                format="+7 ### ### ## ##"
                                mask="_"
                                customInput={TextInput}
                                value={form.values.phone}
                                {...form.getInputProps('phone')}
                                className={S.textInput}
                                size="lg"
                                allowEmptyFormatting
                            />
                            <TextInput
                                label="Укажите, пожалуйста, вашу электронную почту"
                                withAsterisk
                                size="lg"
                                className={S.textInput}
                                key={form.key('email')}
                                {...form.getInputProps('email')}
                            />
                        </div>
                        <div className={S.requiredFieldDiv}>*Обязательное поле</div>
                        <div className={S.buttonDiv}>
                            <Checkbox
                                label={
                                    <div className={event === 5 ? S.labelCheckboxLogistics : S.labelCheckbox}>Я даю своё согласие на обработку <span><u
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            navigate('/privacy-policy');
                                        }}>персональных данных</u>
                                </span>
                                    </div>
                                }
                                key={form.key('check')}
                                {...form.getInputProps('check', {type: 'checkbox'})}
                                color="#0C31C8FF"
                            />
                            <button className={event === 5 ? S.buttonLogistics : S.button}
                                    type="submit">{isLoading ? 'Отправка...' : 'ОТПРАВИТЬ'}</button>
                        </div>
                    </div>
                </form>
            </div>
            <div className={S.backgroundForCompany1}>
                {event === 5 ? (
                    <img src={logistic} alt="logistic"/>
                ) : (
                    <img src={backgroundForCompany1} alt="backgroundForCompany1"/>
                )}
            </div>
        </div>
    );
};